import { Question } from '@funnels/types';
/**
 * usage:
 * const hasQuestion = getQuestionDisplayFields<LICENSED_BUILDER_QUESTIONS>(questions as LICENSED_BUILDER_QUESTIONS[])
 * hasQuestion.TITLE && something
 */
export function getQuestionDisplayFields<Q extends Question>(
  questions: Q[]
): {
  [k in Q]: boolean;
} {
  const hasQuestion = new Proxy(questions, {
    get(target: Q[], prop: Q): boolean {
      return target.includes(prop);
    },
  }) as any;
  return hasQuestion;
}
